import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FileUploadListModalComponent } from './file-upload-list-modal.component';
import { FileUploadOptions, FileInfoType } from '@schoolbelle/api/file';
import { FileUploadListOptions, DefaultFileUploadListOptions } from './file-upload-list.types';

@Injectable()
export class FileUploadListModalService {
  constructor(
    private modal : BsModalService,
  ){
  }
  open(list:Array<[Blob, FileUploadOptions]>, access_token:string, opts?:FileUploadListOptions):Observable<Map<any, FileInfoType>> {
    opts = {
      ...DefaultFileUploadListOptions,
      ...opts,
    }

    const modal = this.modal.show(FileUploadListModalComponent, {backdrop:'static', initialState:{list, access_token, opts}});
    return modal.content.action.pipe(take(1))
  }
}
